// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1M9-O";
var _4 = "info-2GowL";
var _5 = "copy-3scBa";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "info", _5 as "copy" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "info": _4, "copy": _5 }
